type InsertStrategy<T> = number | ((item: T) => boolean);

/**
 * Inserts a new item into an existing array.
 * This can be done by 2 strategies:
 *
 * 1. index - the new item will be inserted at the specified index
 * 2. predicate function - the new item will be inserted directly _after_ the item returned from the predicate.
 */
const insertInto = <T>(items: T[], newItem: T, insertStrategy: InsertStrategy<T>): T[] => {
  const newItemIndex = typeof insertStrategy === "number" ? insertStrategy : items.findIndex(insertStrategy) + 1;

  return [...items.slice(0, newItemIndex), newItem, ...items.slice(newItemIndex)];
};

export default insertInto;
